import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/CinematicLanding";
import ShootPage from "@/pages/ShootPage";
import FilmSchoolPage from "@/pages/FilmSchoolPage";
import ServicesPage from "@/pages/ServicesPage";
import BookShootPage from "@/pages/BookShootPage";
import BookWorkshopPage from "@/pages/BookWorkshopPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import MyOrdersPage from "@/pages/MyOrdersPage";
import PolicyPage from "@/pages/PolicyPage";
import Admin from "@/pages/Admin";
import AuthCallback from "@/components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/shoot" element={<ShootPage />} />
      <Route path="/film-school" element={<FilmSchoolPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/:id" element={<ProductDetailPage />} />
      <Route path="/my-orders" element={<MyOrdersPage />} />
      <Route path="/policies/:slug" element={<PolicyPage />} />
      <Route path="/book-shoot" element={<BookShootPage />} />
      <Route path="/book-workshop" element={<BookWorkshopPage />} />
      <Route path="/booking-success" element={<BookingSuccessPage />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#F4F2ED] min-h-screen">
      <div className="grain-overlay" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}

export default App;
